import {createApp} from 'vue';
import {connectVue} from '../modules/configureBugsnag';
import configureGlobalComponents from '../modules/configureGlobalComponents';
import Gallery from '../components/global/gallery.vue';
import EnquireForm from '../components/global/enquire-form.vue';
import trackSocialClicks from '../helpers/trackSocialClicks';
import disqus from '../vendor/disqus';

const app = createApp({
    props: ['id', 'title', 'category'],
    components: {
        'gallery': Gallery,
        'brochure-button': EnquireForm,
        'testdrive-button': EnquireForm,
        'question-button': EnquireForm,
        'enquire-form': EnquireForm,
    },

    data() {
        return {
            email: '',
        };
    },
    mounted() {
        if (this.category !== 'review') {
            this.openComments();
        }
    },
    methods: {
        openComments() {
            window.addEventListener('scroll', (e) => {
                let currentScroll = 0;
                if (document.scrollingElement?.scrollTop) {
                    currentScroll = document.scrollingElement.scrollTop;
                }
                const disqusTarget = document.getElementById('disqus_thread');
                const disqusLoaded = false;

                if (!this.disqusLoaded) {
                    if (disqusTarget && (currentScroll > disqusTarget.getBoundingClientRect().top - 150)) {
                        disqus(this.id, this.category, this.title.replace('/\£/', '\&pound\;'));
                        console.log('DL');
                        this.disqusLoaded = true;
                    }
                }
            }, false);
        },
        // reviews
        socialClick(type: string, url: string) {
            trackSocialClicks(type);
            if (type !== 'whatsapp') {
                window.open(url, 'enquire form', 'width=600, height=400');
            }
        },
    },
}, window.propsData);

connectVue(app);
configureGlobalComponents(app);

app.mount('#app');
